import { render, staticRenderFns } from "./ArchivesOfEachIssue.vue?vue&type=template&id=5e278836"
import script from "./ArchivesOfEachIssue.vue?vue&type=script&lang=js"
export * from "./ArchivesOfEachIssue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports